import type {
  BranchID,
  CorporationID,
  PlannerID,
  Sex,
  Specialty,
} from '@/types/app'

export type CorporationResponse = {
  id: CorporationID
  name: string
  branches: BranchResponse[]
}

export type CorporationRequest = {
  id: string
  name: string
}

export type BranchResponse = {
  id: BranchID
  name: string
}

export type PlannerProfileResponse = {
  id: PlannerID
  name: string
  avatarUrl: string
  email: string
  slug: string
  corporationId: CorporationID
  branchIds: BranchID[]
  gender: string
  birthday?: DateString | null
  availableAreaCodes: string[]
  availableTime: string
  comment: string
  specialties: ReadonlyArray<Specialty['name']>
  authorities: string[]
  cover?: string | null
  coverUrl?: string | null
}

export type SpecialtiesResponse = ReadonlyArray<
  SpecialtyResponse | MatchingFilterResponse
>

const sexMap: { [K in string]: Sex } = {
  male: 'male',
  female: 'female',
  other: 'noAnswer',
}

export const convertGqlGenderToSex = (gender: string): Sex => sexMap[gender]

export type SpecialtyResponse = {
  id: number
  name: string
}

export type MatchingFilterResponse = {
  id: number
  name: string
}
